<template lang="pug">
  .author
    .row.middle.m-bottom-2
      img.avatar.m-right-1(:src='author.picture')
      h4.title-small {{ author.name }}
    .column.m-bottom-2
      p.text-normal.dark-gray.m-bottom-2.bio(:class='{ellipsis: !showMoreBio}')
        | {{ author.description }}
      span.text-normal.blue.bold.pointer.see-more(v-if='author.description.length > 150' @click='toggleShowMore')
        | {{ showMoreBio ? $t("authorInfo.showMore") : $t("authorInfo.hide") }}
    .row.space-between
      span.text-normal.dark-gray(v-if='author.website')
        | {{ $t("authorInfo.website") }}
        a.text-normal.blue.m-left-05(
          :href='author.website'
          target='_blank'
          rel='noreferrer noopener'
        ) {{ author.website }}
      .row.middle.socials.m-left-auto
        a(
          v-if='author.facebook'
          :href='author.facebook'
          rel='noreferrer noopener'
          target='_blank'
        )
          simple-svg.dark-gray-icon(
            :filepath='facebookIcon'
            width='20px'
            height='20px'
          )
        a(
          v-if='author.instagram'
          :href='author.instagram'
          rel='noreferrer noopener'
          target='_blank'
        )
          simple-svg.dark-gray-icon(
            :filepath='instagramIcon'
            width='20px'
            height='20px'
          )
        a(
          v-if='author.twitter'
          :href='author.twitter'
          rel='noreferrer noopener'
          target='_blank'
        )
          simple-svg.dark-gray-icon(
            :filepath='twitterIcon'
            width='20px'
            height='20px'
          )
    .team(v-if='coAuthors')
      .divider.m-top-2.m-bottom-2
      h4.title-small {{ $t("authorInfo.coAuthors") }}
      .row.coAuthors.middle.m-top-2
        avatar.avatar(
          v-for='user of coAuthors.slice(0,4)'
          :key='user.id'
          :image='user.avatar'
          width='40px'
        )
        v-popover(
          :delay='{show: 100, hide: 100}'
          trigger='click'
          popoverClass='co-authors-popover'
          :container='false'
        )
          button.more-users.row.middle.center.dark-gray.text-normal(v-if='coAuthors.length > 4')
            | {{ "+" + (coAuthors.length - 4) }}
          template(slot='popover')
            h4.title-small {{ $t("authorInfo.coAuthors") }}
            .co-authors-list.column.kimple-scroll.m-top-1
              .user.row.middle(v-for='user of coAuthors' :key='user.id')
                avatar.m-right-1(:image='user.image' width='32px')
                span.item-1.ellipsis.m-right-1.text-normal.bold.dark-gray
                  | {{ user.user.fullName || user.user.email }}
        button.add-more.row.middle.center(v-if='krea' @click='showKreaTeamModal')
          simple-svg.blue-icon(:filepath='plusIcon' width='18px' height='18px')
</template>

<script>
import facebookIcon from '@/assets/ic_facebook.svg'
import instagramIcon from '@/assets/ic_instagram.svg'
import twitterIcon from '@/assets/ic_twitter.svg'
import plusIcon from '@/assets/ic_add.svg'
import Avatar from '../Avatar'
import { mapActions } from 'vuex'
import userPosition from '@/mixins/userPosition'

export default {
  mixins: [userPosition],
  props: {
    author: { type: Object },
    coAuthors: { type: Array },
    krea: { type: Boolean }
  },
  components: { Avatar },
  data() {
    return {
      plusIcon,
      facebookIcon,
      instagramIcon,
      twitterIcon,
      showMoreBio: false
    }
  },
  methods: {
    ...mapActions([
      'showElement'
    ]),
    toggleShowMore() {
      this.showMoreBio = !this.showMoreBio
    },
    showKreaTeamModal() {
      this.showElement({
        element: 'kreaCreateInTeamModal',
        props: { contentId: this.$route.params.id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.author{
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0px 2px 2px 0px #73798540;
}

.divider{
  border-top: 1px solid $gray;
}

.coAuthors{
  .avatar{
    border: 1px solid $white;
  }
  &>*:not(:first-child){
    margin-left: -10px;
  }
  .more-users{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: $light-gray;
    border: 1px solid $white;
    padding-bottom: 4px;
  }
  .add-more{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: $white;
    border: 1px solid $blue;
  }
}
.co-authors-list{
  height: 192px;
  overflow-y: auto;
  gap: 10px;
}

.bio{
  &.ellipsis{
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: pre-wrap;
  }
}
.see-more{
  margin-top: -16px;
}

.socials{
  gap: 10px;
}

.avatar{
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>
